export enum APP_ROUTES {
  HOME = "/",
  LANDING = "/welcome",
  SIGN_UP = "/sign-up",
  SIGN_IN = "/sign-in",
  CHANGE_PASSWORD = "/change-password",
  CONFIRM_EMAIL = "/confirm-email",
  VERIFY_OTP = "/verify-otp",
  CONFIRM_PASSWORD = "/confirm-password",
  FORGET_PASSWORD = "/forget-password",
  ISSUES = "/issues",
  MOTIVATIONAL_LIST = "/motivationals",
  MOTIVATIONAL = "/motivational",
  MOTIVATIONAL_CREATE = "/create-motivational",
  MOTIVATIONAL_EDIT = "/edit-motivational",
  ISSUE = "/issue",
  SOLUTION = "/solution",
  SOLUTION_LIST = "/solutions",
  ACTION_GROUP_LIST = "/action-groups",
  ACTION_GROUP = "/action-group",
  PROFILE = "/profile",
  DASHBOARD = "/dashboard",
  NOTFOUND = "/404",
  BLANK = "/blank",
  ERROR = "/error",
  HANDOUTS = "/handouts",
  ADMIN = "/admin",
  IMPACT = "/impact",
  MOCK_NAVIGATION = "/mock-ups/navigation",
  MOCK_HERO = "/mock-ups/hero",
}

export default APP_ROUTES;
